<template>
  <div>
    <div>
      <div v-if="loaded && companies.length === 0">
        <div class="alert alert-primary" role="alert">شرکنی یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded && companies.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>مدیر شرکت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="company in companies" :key="company.id">
                <td>
                  <div class="w-auto btn-clean d-flex px-2">
                    <span class="ml-3 font-size-lg pt-1">
                      {{ company.title }}
                    </span>
                  </div>
                </td>
                <td>{{ gFullName(company.owner) || "_" }}</td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-companies-show',
                      params: { id: company.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                  <router-link
                    :to="{
                      name: 'admin-company-price',
                      query: { company: company.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    مدیریت قیمت‌ها
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="companiesPagination.lastPage > 1">
      <b-pagination
        v-model="companiesPagination.currentPage"
        :total-rows="companiesPagination.total"
        :per-page="companiesPagination.perPage"
        aria-controls="my-table"
        @input="updateCompanies()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_COMPANIES } from "@/core/services/store/admin/companies.module";
import { mapGetters } from "vuex";

export default {
  name: "companies",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "شرکت ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateCompanies();
  },
  computed: {
    ...mapGetters(["currentUserProperty", "companies", "companiesPagination"])
  },
  methods: {
    updateCompanies() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_COMPANIES)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
